<form [formGroup]="tripInfoForm" class="template-form" *ngIf="_trip != undefined && _trip != null">
  <div data-testid="trip-info-modal-div" class="filter__fields">
    <mat-card class="mat-elevation-z8">
      <mat-card-content>
        <mat-grid-list data-testid="trip-info-grid-list" [cols]="2" gutterSize="10px" rowHeight="90">
          <mat-grid-tile data-testid="trip-name-grid-tile">
            <read-only-form-field title="Trip Name" testId="trip-name">
              <mat-form-field data-testid="trip-name-field">
                <mat-label data-testid="trip-name-field-title">Trip Name: </mat-label>
                <input data-testid="trip-name-input-field" matInput formControlName="tripName">
                <mat-error *ngIf="tripInfoForm.controls['tripName'].hasError('required')">
                  Trip name is required
                </mat-error>
                <mat-error *ngIf="tripInfoForm.controls['tripName'].hasError('tripNameTooLong')">
                  Trip name must be 500 characters or less
                </mat-error>
              </mat-form-field>
            </read-only-form-field>
          </mat-grid-tile>
          <mat-grid-tile data-testid="trip-total-grid-tile">
            <read-only-form-field [readonly]="true" title="Trip Total" testId="trip-total">
              <mat-form-field data-testid="trip-total-field">
                <mat-label data-testid="trip-total-field-title">Trip Total: </mat-label>
                <input data-testid="trip-total-input-field" matInput formControlName="tripTotal">
              </mat-form-field>
            </read-only-form-field>
          </mat-grid-tile>
          <mat-grid-tile data-testid="trip-adjustment-total-grid-tile">
            <read-only-form-field title="Trip Adjustment Total" testId="trip-adjustment-total" [value]="formatPaymentValue(tripAdjustmentTotal)" />
          </mat-grid-tile>
          <mat-grid-tile data-testid="trip-external-number-grid-tile">
            <read-only-form-field title="Adx Quote Number" testId="trip-external-number" value="{{_trip.externalNumber}}" />
          </mat-grid-tile>
          <mat-grid-tile data-testid="trip-external-reference-grid-tile">
            <read-only-form-field title="Trip Record Locator" testId="trip-external-reference" value="{{_trip.externalReference}}" />
          </mat-grid-tile>
          <mat-grid-tile>
            <read-only-form-field title="Trip Start Date" testId="trip-start-date" [isDate]="true">
              <mat-form-field data-testid="trip-start-date-field">
                <mat-label data-testid="trip-start-date-field-title">Trip Start Date: </mat-label>
                <input
                data-testid="trip-start-date-input-field"
                  matInput
                  [matDatepicker]="picker1"
                  formControlName="tripStartDate"
                  [min]="currentDate">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle [disabled]="true" matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 id="trip-start-date-datepicker"></mat-datepicker>
                <mat-error *ngIf="tripInfoForm.controls['tripStartDate'].hasError('required')">
                  Trip start date is required
                </mat-error>
              </mat-form-field>
            </read-only-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <read-only-form-field title="Trip End Date" testId="trip-end-date" [isDate]="true">
              <mat-form-field data-testid="trip-end-date-field">
                <mat-label data-testid="trip-end-date-field-title">Trip End Date: </mat-label>
                <input
                  data-testid="trip-end-date-input-field"
                  matInput
                  [matDatepicker]="picker2"
                  formControlName="tripEndDate"
                  [min]="currentDate">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle [disabled]="true" matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 id="trip-start-date-datepicker"></mat-datepicker>
                <mat-error *ngIf="tripInfoForm.controls['tripEndDate'].hasError('required')">
                  Trip end date is required
                </mat-error>
                <mat-error *ngIf="tripInfoForm.controls['tripEndDate'].hasError('endDateInvalid')">
                  Trip end date must be after the start date
                </mat-error>
              </mat-form-field>
            </read-only-form-field>
          </mat-grid-tile>
        </mat-grid-list>
      </mat-card-content>
    </mat-card>
    <br>
    <div>
      <h2 data-testid="payment-totals-title" class="page-details-title-style">Payment Totals</h2>
    </div>
    <mat-card class="mat-elevation-z8">
      <mat-card-content>
        <mat-grid-list data-testid="payment-totals-grid-list" [cols]="2" gutterSize="10px" rowHeight="90">
          <mat-grid-tile data-testid="open-client-payments-grid-tile">
            <read-only-form-field title="Open Payments Received From Client" testId="open-client-payments" [value]="formatPaymentValue(paymentTotals.totalOpenPaymentsReceivedFromClient)" />
          </mat-grid-tile>

          <mat-grid-tile data-testid="closed-client-payments-grid-tile">
            <read-only-form-field title="Closed Payments Received From Client" testId="closed-client-payments" [value]="formatPaymentValue(paymentTotals.totalClosedPaymentsReceivedFromClient)" />
          </mat-grid-tile>

          <mat-grid-tile data-testid="open-vendor-payments-grid-tile">
            <read-only-form-field title="Open Payments To Vendor" testId="open-vendor-payments" [value]="formatPaymentValue(paymentTotals.totalOpenPaymentsMadeToVendor)" />
          </mat-grid-tile>

          <mat-grid-tile data-testid="closed-vendor-payments-grid-tile">
            <read-only-form-field title="Closed Payments To Vendor" testId="closed-vendor-payments" [value]="formatPaymentValue(paymentTotals.totalClosedPaymentsMadeToVendor)" />
          </mat-grid-tile>
        </mat-grid-list>
      </mat-card-content>
    </mat-card>
  </div>
</form>
